import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import useFetchACHWithdrawTransaction from '@/hooks/useApi/useFetchACHWithdrawTransaction';
import AchWithdrawalTransactionInfo from './ACHWithdrawalTransactionInfo';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

type AchWithdrawalTransactionProps = {
  TransactionID: string;
  Notes: string;
};

type FC = FunctionComponent<AchWithdrawalTransactionProps>;

const AchWithdrawalTransactionContainer: FC = (props: AchWithdrawalTransactionProps) => {
  const { TransactionID, Notes } = props;
  const { userSettings } = useUserSettingsProvider();
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.ACHWithdrawTransactionResponse>();
  const [achWithdrawalTransaction, getAchWithdrawTransaction, resetTransactionsId] = useFetchACHWithdrawTransaction({
    bearer: '',
  });

  useEffect(() => {
    getAchWithdrawTransaction({ TransactionID, Timezone: userSettings.timezone });
  }, [currentTransactionId, TransactionID]);

  useEffect(() => {
    if (achWithdrawalTransaction) {
      setTransaction(achWithdrawalTransaction);
    }
  }, [achWithdrawalTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
    resetTransactionsId();
  }

  return <div>{transaction && <AchWithdrawalTransactionInfo transaction={transaction} Notes={Notes} />}</div>;
};

export default AchWithdrawalTransactionContainer;
